import Moment from 'moment';
import { extendMoment } from 'moment-range';

const dateRange = extendMoment(Moment);

const doRangesOverlap = (from1, to1, from2, to2, adjacent = true) => {
  const range1 = dateRange.range(from1, to1);
  const range2 = dateRange.range(from2, to2);

  return range1.overlaps(range2, { adjacent });
};

export default doRangesOverlap;
